export default __webpack_public_path__ + "static/media/chef.02d6c5b6.png";